export const UNIT_STATUSES = ["available", "occupied", "maintenance", "inactive"] as const;

const UNIT_STATUS_LABELS: Record<string, string> = {
  available: "Available",
  occupied: "Occupied",
  maintenance: "Maintenance",
  inactive: "Inactive",
};

export function unitStatusLabel(status: string): string {
  return UNIT_STATUS_LABELS[status] ?? status;
}

export function unitStatusBadge(status: string): string {
  if (status === "occupied") return "ok";
  if (status === "maintenance") return "warn";
  if (status === "inactive") return "muted";
  return "info";
}
